import { Link, animateScroll as scroll } from 'react-scroll'

export default () => {
    return (
        <div className="relative pb-24">
            <div className="max-w-3xl mx-auto text-center mb-12">
                <h2 className="mt-2 text-5xl text-white font-custom italic font-bold uppercase">In dit boek </h2>
            </div>
            <div className="w-full mx-auto md:grid md:grid-cols-2">
                <div className="py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:px-10 lg:px-16 bg-we-are-yellow">
                    <div className="mt-6 md:flex-grow md:flex md:flex-col">
                        <div className="relative text-lg font-base text-gray-900 md:flex-grow">
                            <h3 className="text-3xl">Lees je waarom</h3>
                            <ul className="list-disc mt-4 max-w-md mx-auto text-lg sm:text-xl md:mt-5 md:max-w-3xl">
                                <li className="ml-0 pl-0">Het jou (nog) niet is gelukt om een voedingsschema succesvol te volgen</li>
                                <li className="ml-0 pl-0">Het jou (nog) niet lukt om gezonde gewoontes vast te houden</li>
                                <li className="ml-0 pl-0">Je telkens terugvalt in je oude patronen</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:px-10 lg:px-16 bg-we-are-purple">
                    <div className="mt-6 md:flex-grow md:flex md:flex-col">
                        <div className="relative text-lg font-base text-gray-100 md:flex-grow">
                            <h3 className="text-3xl">Leer je</h3>
                            <ul className="list-disc mt-4 max-w-md mx-auto text-lg sm:text-xl md:mt-5 md:max-w-3xl">
                                <li className="ml-0 pl-0">Waarom conditionering een belangrijk rol speelt in jouw strijd</li>
                                <li className="ml-0 pl-0">Welke vijf blokkades er zijn en hoe je deze kan ombuigen</li>
                                <li className="ml-0 pl-0">Welke vijf overtuigingen je nodig hebt om succesvol af te vallen</li>
                                <li className="ml-0 pl-0">Nieuwe inzichten door praktische tips en opdrachten</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-center mt-12">
                <Link
                    to="book"
                    smooth={true}
                    offset={0}
                    duration={500}
                    className="uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                >
                    Bekijk inkijkexemplaar
                </Link>
            </div>
        </div>
    )
}